import { render, staticRenderFns } from "./Booths.vue?vue&type=template&id=7fdeb298&scoped=true&"
import script from "./Booths.vue?vue&type=script&lang=ts&"
export * from "./Booths.vue?vue&type=script&lang=ts&"
import style0 from "./Booths.vue?vue&type=style&index=0&id=7fdeb298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdeb298",
  null
  
)

export default component.exports